<ul class="youth-info-center-card-details-list">
  <li *ngIf="phone" class="youth-info-center-card-details-list__item">
    <app-chip>
      <mat-icon matPrefix svgIcon="phone" role="presentation"></mat-icon>
      <a
        ignoreExternLink
        class="link--primary youth-info-center-card-details-list__item__link"
        [href]="'tel:' + phone"
        [attr.aria-label]="'Appeller le ' + phone"
        (click)="
          trackEvent({
            category: 'Accompagnement',
            action: 'Click Téléphone',
            type: 'navigation'
          })
        "
      >
        {{ phone }}
      </a>
    </app-chip>
  </li>
  <li *ngIf="email" class="youth-info-center-card-details-list__item">
    <app-chip>
      <mat-icon matPrefix svgIcon="email" role="presentation"></mat-icon>
      <a
        class="link--primary youth-info-center-card-details-list__item__link"
        ignoreExternLink
        [href]="'mailto:' + email"
        [attr.aria-label]="'Envoyer un email à ' + name"
        (click)="
          trackEvent({
            category: 'Accompagnement',
            action: 'Click Email',
            type: 'navigation'
          })
        "
      >
        {{ email }}
      </a>
    </app-chip>
  </li>
  <li *ngIf="url" class="youth-info-center-card-details-list__item">
    <app-chip>
      <mat-icon svgIcon="url" role="presentation"></mat-icon>
      <a
        class="link--primary youth-info-center-card-details-list__item__link"
        [href]="url"
        target="_blank"
        [attr.aria-label]="'Consulter le site internet de ' + name"
        (click)="
          trackEvent({
            category: 'Accompagnement',
            action: 'Click Site Web',
            type: 'navigation'
          })
        "
      >
        {{ url | ellipsis: 30 }}
      </a>
    </app-chip>
  </li>
  <li class="youth-info-center-card-details-list__schedules">
    <app-schedule [schedules]="parsedSchedules"></app-schedule>
  </li>
</ul>
